module.exports = __webpack_public_path__ + "static/media/bg1.f3029ba9.jpg";